// extracted by mini-css-extract-plugin
export var section = "footer-module--section--EQ3ZV";
export var container = "footer-module--container--o6B43";
export var left = "footer-module--left--s26r3";
export var right = "footer-module--right--iONNA";
export var phone = "footer-module--phone--6FID7";